/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-31 17:00:27
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-30 14:30:09
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelCategory/Components/Card/index.tsx
 */
import React from 'react';
import css from './css.module.less';

import ItemWrapper from '@/src/components/Layouts/Item/Item';
import Row from '@/src/components/Layouts/Row/Row';

import { Button } from 'src/components/Antd';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const GeneralCard = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { isRoot, name, parent, slug, url, canEdit, onEdit } = props;

  return (
    <div className={css.container}>
      <Row
        elements={[
          {
            child: (
              <ItemWrapper title={getI18n('general.categoryName')}>
                {name}
              </ItemWrapper>
            ),
          },
          isRoot
            ? {
                child: (
                  <ItemWrapper title={getI18n('general.uRLSlug')}>
                    {slug}
                  </ItemWrapper>
                ),
              }
            : {
                child: (
                  <ItemWrapper title={getI18n('general.parent')}>
                    {parent}
                  </ItemWrapper>
                ),
              },
        ]}
      />
      {!isRoot && (
        <Row
          elements={[
            {
              child: (
                <ItemWrapper title={getI18n('general.uRLSlug')}>
                  {slug}
                </ItemWrapper>
              ),
            },
            {
              child: (
                <ItemWrapper title={getI18n('general.uRL')}>{url}</ItemWrapper>
              ),
            },
          ]}
        />
      )}
      {canEdit && (
        <Button onClick={onEdit} className={css.editBtn}>
          {getI18n('general.edit')}
        </Button>
      )}
    </div>
  );
};

const ContentCard = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { isRoot, name, parent, slug, url, onEdit, contentVersion } = props;

  return (
    <div className={css.container}>
      <Row
        elements={[
          {
            child: (
              <ItemWrapper title={getI18n('general.categoryName')}>
                {name}
              </ItemWrapper>
            ),
          },
          isRoot
            ? {
                child: (
                  <ItemWrapper title={getI18n('general.uRLSlug')}>
                    {slug}
                  </ItemWrapper>
                ),
              }
            : {
                child: (
                  <ItemWrapper title={getI18n('general.contentVersion')}>
                    {contentVersion}
                  </ItemWrapper>
                ),
              },
        ]}
      />
      {!isRoot && (
        <Row
          elements={[
            {
              child: (
                <ItemWrapper title={getI18n('general.parent')}>
                  {parent}
                </ItemWrapper>
              ),
            },
            {
              child: (
                <ItemWrapper title={getI18n('general.uRLSlug')}>
                  {slug}
                </ItemWrapper>
              ),
            },
          ]}
        />
      )}
      {!isRoot && (
        <Row
          elements={[
            {
              child: (
                <ItemWrapper title={getI18n('general.uRL')}>{url}</ItemWrapper>
              ),
            },
          ]}
        />
      )}

      <Button onClick={onEdit} className={css.editBtn}>
        {getI18n('general.edit')}
      </Button>
    </div>
  );
};

const GeneralCard1 = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { contentList = [], canEdit, onEdit } = props;

  return (
    <div className={css.container}>
      {contentList.map((row = [], index) => {
        return (
          <Row
            key={index}
            elements={row.map((item) => {
              const { label, value } = item;
              return {
                child: (
                  <ItemWrapper key={value} title={label}>
                    {value}
                  </ItemWrapper>
                ),
              };
            })}
          />
        );
      })}
      {canEdit && (
        <Button onClick={onEdit} className={css.editBtn}>
          {getI18n('general.edit')}
        </Button>
      )}
    </div>
  );
};

export { ContentCard, GeneralCard1 };
export default GeneralCard;
